import { useRef } from "react";
import "./ability-cooldown.css";

/** The clock follows the observed server cooldown, including after reconnect. */
export function AbilityCooldown({ seconds }: { seconds: number }) {
  const cycle = useRef({ previous: seconds, maximum: seconds });
  if (seconds <= 0 || seconds > cycle.current.previous)
    cycle.current.maximum = seconds;
  cycle.current.previous = seconds;
  if (seconds <= 0) return null;
  const remaining = Math.min(100, 100 * seconds / cycle.current.maximum);
  return <span className="ability-cooldown" aria-hidden="true">
    <svg viewBox="0 0 100 100">
      <circle className="ability-cooldown-track" cx="50" cy="50" r="47" />
      <circle className="ability-cooldown-remaining" cx="50" cy="50" r="47" pathLength="100"
        strokeDasharray={`${remaining} 100`} />
    </svg>
  </span>;
}
